import React, { useState, useEffect, useCallback, useRef } from 'react';
import PropTypes from 'prop-types';
import Dropdown from 'rc-dropdown';
import { useHistory } from 'react-router-dom';

import { useDispatch, useSelector } from 'react-redux';
import { Auth } from 'store/auth/actions';
import { CashWarrant } from 'store/cashWarrant/actions';
import { userDataSelector } from 'store/auth/selectors';
import { cashBoxListSelector, cashBoxListStockSelector, cashBoxListOrgSelector } from 'store/cashWarrant/selectors';
import { Icon } from 'components/Icon';
import { InputIcon } from 'components/Input';
import { Button, ButtonIcon } from 'components/Button';
import { InputAutoComplete } from 'components/InputAutoComplete/InputAutoComplete';
import { ModalUserOption } from 'components/ModalUserOption';
import { actStatusesSelector } from 'store/transferAct/selectors';
import { Rent } from 'store/transferAct/actions';
import '../style.scss';

const items = {
  legal: 'Юр. лица',
  individ: 'Физ. лица',
};

export const MainHeader = ({
  title,
  user,
  onSearch,
  isTable,
  setIsTable,
  status,
  setStatus,
  columnSearch,
  item,
  setItem,
}) => {
  const dispatch = useDispatch();
  const userData = useSelector(userDataSelector);
  const statusList = useSelector(actStatusesSelector);
  const cashBoxList = useSelector(cashBoxListSelector);
  const cashBoxListStock = useSelector(cashBoxListStockSelector);
  const cashBoxListOrg = useSelector(cashBoxListOrgSelector);
  const [searchItem, setSearchItem] = useState(items.individ);
  const [showMenu, setShowMenu] = useState(false);
  const history = useHistory();

  const [search, setSearch] = useState(columnSearch.string);
  const [modal, setModal] = useState(false);
  const [modalUserOption, setModalUserOption] = useState(false);
  const menuRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setShowMenu(false);
      }
    }

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [menuRef]);

  useEffect(() => {
    if (modal) {
      if (!cashBoxList?.length) {
        dispatch(CashWarrant.getCashBoxes());
      }
      if (!cashBoxListStock?.length) {
        dispatch(CashWarrant.getCashBoxStock());
      }
      if (!cashBoxListOrg?.length) {
        dispatch(CashWarrant.getCashBoxOrg());
      }
    }
  }, [modal]);

  useEffect(() => {
    if (statusList.length === 0) {
      dispatch(Rent.getRentActStatuses());
    }
  }, [statusList]);

  const changeCashBox = (selector) => {
    dispatch(Auth.setCashBox(selector));
  };

  const changeStock = (selector) => {
    dispatch(Auth.setStock(selector));
  };

  const changeOrg = (selector) => {
    dispatch(Auth.setOrg(selector));
  };

  const handleLogout = () => {
    dispatch(Auth.logOut());
  };

  const handleModal = (e, toggle) => {
    e.stopPropagation();
    setModal(toggle);
  };

  const handleSearch = (value) => {
    if (onSearch) {
      onSearch(searchItem, value);
    }
    setSearch(value);
  };

  const handleResetItem = () => {
    setItem(undefined);
  };

  const handleShowMenu = () => {
    setShowMenu(!showMenu);
  };
  const handleReset = () => {
    setStatus('');
    handleSearch('');
    handleResetItem();
  };

  const handleMenuClick = ({ key }) => {
    handleShowMenu(false);

    switch (key) {
      case '1':
        history.push('/reservation');
        return;
      case '2':
        history.push('/rent');
        return;
    }
  };

  const canReset = useCallback(() => {
    return item || status || columnSearch.string;
  }, [item, status, columnSearch]);

  return (
    <header className="header">
      <div className="header-main">
        <div className="header-title">{title}</div>
        <InputIcon
          icon="search"
          onChange={handleSearch}
          value={search}
          placeholder={searchItem === items.individ ? 'ФИО или номер' : 'Наименование или ЕДРПОУ'}
        />
        {isTable && (
          <>
            <InputAutoComplete
              selected={{ value: status, text: status }}
              list={statusList.map((elem) => ({
                text: elem,
                value: elem,
                returning: elem,
              }))}
              placeholder="Статусы"
              size="180px"
              onChange={setStatus}
            />
            <div>
              <Dropdown
                placement="topLeft"
                visible={showMenu}
                overlay={
                  <ul className="creation-menu" ref={menuRef}>
                    <li onClick={() => handleMenuClick({ key: '1' })}>Резерв</li>
                    <li onClick={() => handleMenuClick({ key: '2' })}>Аренда</li>
                  </ul>
                }
              >
                <Button className="btn btn-add-main" onClick={handleShowMenu}>
                  Добавить
                </Button>
              </Dropdown>
            </div>
          </>
        )}
        {!!item && (
          <div
            className="item-main-header"
            data-for="comments-table"
            data-tip={item.title.length <= 18 ? '' : item.title}
          >
            {item.title.length <= 18 ? item.title.value : `${item.title.substring(0, 16)}...`}
          </div>
        )}
        {canReset() && (
          <div className="reset-main-header" onClick={handleReset}>
            Очистить
          </div>
        )}
      </div>
      {modalUserOption && (
        <ModalUserOption
          onClose={() => {
            setModalUserOption(false);
          }}
        />
      )}
      <div className="header-profile">
        {!isTable && (
          <div className="header-notifications">
            <Icon
              name="gear"
              tooltipText="Настроить отображение актов на главной"
              onClick={() => {
                setModalUserOption(!modalUserOption);
              }}
            />
          </div>
        )}
        <div className="header-notifications">
          <Icon
            name={isTable ? 'view-vertical' : 'view'}
            tooltipText={isTable ? 'Отобразить как колоники' : 'Отобразить как таблицу'}
            onClick={() => {
              setIsTable(!isTable);
            }}
          />
        </div>
        <div className="header-user" onClick={(e) => handleModal(e, true)}>
          <img className="header-user-icon" src="images/user-img-placeholder.jpg" alt="Avatar" />

          <div className="header-user-name">{user.fio_short}</div>

          {modal && (
            <div className="header-button-modal">
              <div className="abstract-button-main" onClick={(e) => handleModal(e, false)}>
                <img className="header-user-icon" src="images/user-img-placeholder.jpg" alt="Avatar" />
                <span className="button-text">{user.fio_short}</span>
              </div>

              <div className="modal-body">
                <InputAutoComplete
                  icon="search"
                  onChange={changeCashBox}
                  list={cashBoxList?.map((item) => ({
                    value: item.id,
                    text: item.name,
                    returning: item.id,
                  }))}
                  selected={
                    (userData?.cashbox && {
                      value: userData.cashbox.id,
                      text: userData.cashbox.name,
                    }) ||
                    null
                  }
                  className="input-autocomplete-main-header"
                  placeholder="Касса"
                  type="text"
                  size="none"
                />
                <InputAutoComplete
                  icon="search"
                  onChange={changeStock}
                  list={cashBoxListStock?.map((item) => ({
                    value: item.stockID1C,
                    text: item.stockName,
                    returning: item.stockID1C,
                  }))}
                  selected={
                    (userData?.defaultStock && {
                      value: userData.defaultStock.id,
                      text: userData.defaultStock.name,
                    }) ||
                    null
                  }
                  className="input-autocomplete-main-header"
                  placeholder="Основной склад"
                  type="text"
                  size="none"
                />

                <InputAutoComplete
                  icon="search"
                  onChange={changeOrg}
                  list={cashBoxListOrg.results?.map((item) => ({
                    value: item.orgID1C,
                    text: item.orgName,
                    returning: item.orgID1C,
                  }))}
                  selected={
                    (userData?.cashbox && {
                      value: userData.defaultOrg.id,
                      text: userData.defaultOrg.name,
                    }) ||
                    null
                  }
                  className="input-autocomplete-main-header"
                  placeholder="Основной ФОП"
                  type="text"
                  size="none"
                />
              </div>

              <div className="flex-center">
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href={`${process.env.REACT_APP_BOT_URL}${userData?.id}`}
                  className="telegram-link"
                >
                  <div className="icon-telegram" />
                  <div className="link-label">Подключить</div>
                </a>
              </div>

              <div className="flex-center">
                <ButtonIcon className="btn-modal" onClick={handleLogout} icon="logout" text="Выйти" />
              </div>
            </div>
          )}
        </div>
      </div>
    </header>
  );
};

MainHeader.propTypes = {
  title: PropTypes.string,
  user: PropTypes.object,
  columnSearch: PropTypes.object,
  notifications: PropTypes.object,
  onSearch: PropTypes.func,
  isTable: PropTypes.bool,
  setIsTable: PropTypes.func,
  status: PropTypes.string,
  item: PropTypes.object,
  setStatus: PropTypes.func,
  setItem: PropTypes.func,
};

MainHeader.defaultProps = {
  title: '',
  user: {},
  notifications: {
    count: 0,
    list: [],
  },
};
